<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div style="overflow:auto">
            <b-table
              id="terminal-activity-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:head(online)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(shop_code)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(shop_name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(terminal_name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(last_connected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(last_disconnected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(first_ticket_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(last_ticket_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(tickets_number)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(tickets_canceled)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(operator)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(shop_status)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(duration)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(online)="data">
                <span v-if="data.value" class="text-success">{{$t("ONLINE")}}</span>
                <span v-else class="text-danger">{{$t("OFFLINE")}}</span>
              </template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>
              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>
              <template v-slot:cell(terminal_name)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>
              <template v-slot:cell(username)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/users/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(last_connected_at)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(last_disconnected_at)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>{{$t("IN PROGRESS")}}</span>
              </template>
              <template v-slot:cell(first_ticket_time)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(last_ticket_time)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>-</span>
              </template>
            </b-table>
          </div>
          <!--div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'terminal-activity-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import PaginationSelect from "@/components/PaginationSelect";
import TerminalData from "./TerminalData";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "terminal-activity",
  props: ["selected"],
  components: {
    PaginationSelect
  },
  data: function() {
    return {
      tableName: "terminal-activity",
      isBusy: false,
      sortBy: "report_time",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "online",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "shop_code",
          label: "Code",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "terminal_name",
          label: "Terminal",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "username",
          label: "Username",
          sortable: false,
          class: "",
          ignore: true
        },
        { key: "last_connected_at", sortable: false, class: "" },
        {
          key: "last_disconnected_at",
          sortable: false,
          class: "",
          ignore: true
        },
        { key: "duration", sortable: false, class: "", ignore: true },
        {
          key: "first_ticket_time",
          label: "Date when first ticket was created",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "last_ticket_time",
          label: "Date when last ticket was created",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "tickets_number",
          label: "# cashed in ticket",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "tickets_canceled",
          label: "# storned in ticket",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "shop_status",
          label: "Status",
          sortable: false,
          class: "",
          ignore: true
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      selectedeid: "",
      paginationOpts: [
        { value: 5 },
        { value: 10 },
        { value: 15 },
        { value: 25 },
        { value: 50 }
      ]
    };
  },
  watch: {
    selected() {
      this.refresh();
    }
  },
  computed: {
    tableDateLong() {
      return timeFormat.tableDateLong;
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "terminal-activity-table");
    },
    provider(ctx, callback) {
      if (!this.selected.terminalID) {
        callback([]);
        return;
      }
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      paginationData.likeValues = [];
      paginationData.likeFields = [];

      if (this.sortBy) {
        let sortBy = this.sortBy;
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      exactFields.push("terminal_id");
      exactValues.push([this.selected.terminalID]);

      paginationData.dateField = "report_time";
      paginationData.dateStart = this.selected.startTime;
      paginationData.dateEnd = this.selected.endTime;

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      this.$store
        .dispatch("terminalActivity/fetchDetails", paginationData)
        .then(resp => {
          this.totalRows = resp.data.length;
          resp.data.forEach((item, index) => {
            if (item.username) {
              if (item.user_id) {
                item.username = {
                  to: item.user_id,
                  name: item.username
                };
              } else {
                item.username = {
                  to: null,
                  name: item.username
                };
              }
            }
            if (item.shop_code) {
              if (item.shop_id) {
                item.shop_code = {
                  to: item.shop_id,
                  name: item.shop_code
                };
              } else {
                item.shop_code = {
                  to: null,
                  name: item.shop_code
                };
              }
            }

            if (item.shop_name) {
              if (item.shop_id) {
                item.shop_name = {
                  to: item.shop_id,
                  name: item.shop_name
                };
              } else {
                item.shop_name = {
                  to: null,
                  name: item.shop_name
                };
              }
            }

            if (item.terminal_name) {
              if (item.shop_id) {
                item.terminal_name = {
                  to: item.shop_id,
                  name: item.terminal_name
                };
              } else {
                item.terminal_name = {
                  to: null,
                  name: item.terminal_name
                };
              }
            }

            item.duration = this.duration(
              item.last_connected_at,
              item.last_disconnected_at
            );
          });
          callback(resp.data);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      return null;
    },
    rowClicked(item, index, event) {},
    mom_unix(val) {
      return moment.unix(val / 1e9);
    },
    duration(sd, ed) {
      sd = this.mom_unix(sd);
      if (ed === 0) {
        ed = moment();
      } else {
        ed = this.mom_unix(ed);
      }
      const dr = moment.duration(ed.diff(sd));
      let ret = "";
      if (dr.days()) {
        ret = `${dr.days()}d `;
      }
      if (dr.hours()) {
        ret = ret + `${dr.hours()}h `;
      }
      if (dr.minutes()) {
        ret = ret + `${dr.minutes()} min `;
      }
      if (dr.seconds()) {
        ret = ret + `${dr.seconds()} sec `;
      }
      return ret;
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
</style>


